module.exports = __webpack_public_path__ + "static/evan.5f58da6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/quote_assets/evan.png
// module id = 1109
// module chunks = 35783957827783